import * as React from 'react';

import {
  ModalFrame,
  ModalFrameFooter,
  ModalFrameInner
} from 'components/modal';
import { Form } from 'components/form';
import ActionButton from 'components/buttons/action-button/ActionButton';
import InputRadio from 'components/inputs/input-radio/InputRadio';
import InputCheckbox from 'components/inputs/input-checkbox/InputCheckbox';
import Popover from 'components/popover/Popover';

import { __t, applyTranslations } from 'utils/language';
import { sanitizeGenericHtml } from 'utils/sanitize';

import './campaign-kpi-setting.scss';

applyTranslations(require('./campaign-kpi-setting.i18n.json'));

import type {
  KpiSettingValues
} from 'modules/reporting/types';

import type { SyntheticEvent } from 'react';

type Props = {
  onCloseModal: () => void,
  onSavingKpiSetting: (b: KpiSettingValues, a: boolean) => void,
  kpiSettingValue: KpiSettingValues
};

type State = {
  value: KpiSettingValues,
  saveSettingForUpcomingCamapign: boolean
};

const KPI_SETTING_TYPES = ['total_of_snippets', 'highest_of_snippets', 'average_of_snippets'];

const CampaignKpiSetting = (props: Props): JSX.Element => {
  const { onCloseModal, onSavingKpiSetting, kpiSettingValue } = props;
  const [state, setState] = React.useState<State>({
    saveSettingForUpcomingCamapign: false,
    value: kpiSettingValue
  });

  const handleChangeChannelType = (event: SyntheticEvent<HTMLInputElement>): void => {
    const { currentTarget } = event;
    const value = currentTarget.value;
    const name = currentTarget.name;

    setState((prevState) => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleSavingKpiSetting = (
    kpiSetting: KpiSettingValues,
    saveSetting: boolean
  ): void => {
    onCloseModal();
    onSavingKpiSetting(kpiSetting, saveSetting);
  };

  const handleToggle = (): void => {
    setState({
      ...state,
      saveSettingForUpcomingCamapign: !state.saveSettingForUpcomingCamapign
    });
  };

  const renderForm = (): JSX.Element => {
    const { value, saveSettingForUpcomingCamapign } = state;

    return (
      <div>
        <div className="campaign-kpi-setting__form-kpi-setting-label">
          <div className="campaign-kpi-setting__label-text">
            {__t('campaign_kpi_setting.form.kpi_setting_label')}
          </div>
          <Popover showQuestionMark>
            <div className="campaign-kpi-setting-tooltip">
              <div className="campaign-kpi-setting-tooltip-headline">
                {__t('campaign_kpi_setting.tooltip_headline')}
              </div>
              <div dangerouslySetInnerHTML={{ __html: sanitizeGenericHtml(__t('campaign_kpi_setting.tooltip_body')) }} />
            </div>
          </Popover>
        </div>
        {
          KPI_SETTING_TYPES.map(option => (
            <InputRadio
              id={`campaign-kpi-setting-form-${option}`}
              key={`campaign-kpi-setting-form-${option}`}
              name="value"
              label={__t(`campaign_kpi_setting.form.kpi_setting_type.${option}`)}
              value={option}
              checked={value === option}
              onChange={handleChangeChannelType}
            />
          ))
        }
        <div className="campaign-kpi-setting__checkbox-container">
          <InputCheckbox
            id={`row-checkbox-${Math.random()}`}
            checked={saveSettingForUpcomingCamapign}
            onChange={handleToggle}
            label={__t('campaign_kpi_setting.form.settings_for_future_campaign_label')}
          />
        </div>
      </div>
    );
  };

  const renderFooter = (): JSX.Element => (
    <React.Fragment>
      <ActionButton
        color="tertiary"
        onClick={onCloseModal}
      >
        {__t('campaign_kpi_setting.action_button.cancel')}
      </ActionButton>
      <ActionButton
        color="primary"
        type="submit"
      >
        {__t('campaign_kpi_setting.action_button.save')}
      </ActionButton>
    </React.Fragment>
  );

  const { value, saveSettingForUpcomingCamapign } = state;

  return (
    <ModalFrame title={__t('campaign_kpi_setting.header_title')}>
      <ModalFrameInner>
        <Form
          onSubmit={() => handleSavingKpiSetting(value, saveSettingForUpcomingCamapign)}
        >
          { renderForm() }
          <ModalFrameFooter noMargin>
            { renderFooter() }
          </ModalFrameFooter>
        </Form>
      </ModalFrameInner>
    </ModalFrame>
  );
};


export default CampaignKpiSetting;
